import React from "react";
import { Route, Redirect } from "react-router-dom";
import { store } from "../../helpers";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => 
      true || store.getState().authentication.jwt ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/auth", state: { from: props.location } }} />
      )
    }
    
  />
);
